module.exports = __webpack_public_path__ + "img/ctrl-hadamard-dagger-stub--i.ad14121c.svg";